// extracted by mini-css-extract-plugin
export default {"box":"index_box_DILh5","logo":"index_logo_u-EdH","people":"index_people_Vl6fK"};